import { CButton, CCard, CCardBody, CCol, CForm, CInputGroup, CRow } from '@coreui/react'
import React, { useEffect, useRef, useState } from 'react'
import BaseListing from 'src/BaseListings'
import { wtApiCall } from '../../helpers/commons/ApiWrapper'
import { lzNotifyErrorMessageFromResult } from '../../helpers/commons/notifications'
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import moment from 'moment'
// import DataReportTable from './DataReportTable'
import EvaluationSummaryReportDataTable from './EvaluationSummaryReportDataTable'

import Loading from 'src/helpers/commons/loader'
import WidgetSelector from 'src/widgets/Selectors/WidgetSelector'
import { useDownloadExcel } from 'react-export-table-to-excel'
import { YesNoOptions } from 'src/helpers/commons/dropdownOptions'
import AttendanceReportLegends from 'src/widgets/Legends/AttendanceReportLegends'
import { wtRoundNumberToSpecifedDigits } from 'src/helpers/commons/utils'
import WidgetDepartmentSelector from '../../widgets/Selectors/WidgetDepartmentSelector'
import { DatePicker } from 'antd'
import Column from 'antd/es/table/Column'
import WidgetDesignationSelector from 'src/widgets/Selectors/WidgetDesignationSelector'
import { wtGetDateMonthYearFormat } from 'src/helpers/commons/moment'
const { RangePicker } = DatePicker
export default function OvertimeReport() {
  const Base = new BaseListing()
  const tableRef = useRef(null)
  const [isLoading, setIsLoading] = useState(false)
  const [errors, setErrors] = useState([])
  const [reportData, setReportData] = useState([])
  const [leaveTypeData, setLeaveTypeData] = useState([])

  const [departments, setDepartments] = useState([])
  const [department_id, setDepartmentId] = useState(0)
  const [department_name, setDepartmentName] = useState('')
  const [designations, setDesignations] = useState([])
  const [designation_id, setDesignationId] = useState(0)
  const [designation_name, setDesignationName] = useState('')

  const [range, setRange] = useState(null)
  const [reportDataMonths, setReportDataMonths] = useState([])
const generatePDF = () => {
  const doc = new jsPDF('landscape')
  const logo = 'assets/wil-icon.png'
  const img = new Image()
  let totalPagesExp = '{total_pages_count_string}'
  let yPosition = 45

  // Sort months chronologically
  const parseMonthYear = (monthYear) => {
    const [month, year] = monthYear.split('-')
    return new Date(`${month} 1, ${year}`)
  }

  const sortedMonths = [...reportDataMonths].sort((a, b) => {
    return parseMonthYear(a.evaluation_months) - parseMonthYear(b.evaluation_months)
  })

  // Build header row
  const headRows = [
    { content: 'Sr' },
    { dataKey: 'id', content: 'Id' },
    { dataKey: 'full_name', content: 'Full Name' },
    { dataKey: 'designation.name', content: 'Designation' },
    { dataKey: 'branch.name', content: 'Branch' },
    { dataKey: 'department.name', content: 'Department' },
    { dataKey: 'date_of_joining', content: 'Date Of Joining' },
    ...sortedMonths.map((m) => ({
      dataKey: 'evaluation_month',
      content: m.evaluation_months,
    })),
    { dataKey: 'total', content: 'Total' },
    { dataKey: 'percentage', content: 'Percentage' },
  ]

  // Build body rows
  const employeeDetails = reportData.map((employee, index) => {
    // Sort evaluations by month using the same sortedMonths array
    const sortedEvaluations = sortedMonths.map((m) =>
      employee.evaluations.find((e) => e.evaluation_month === m.evaluation_months)
    )

    const totalRating = sortedEvaluations.reduce(
      (acc, e) => acc + (e?.rating || 0),
      0
    )
    const totalMaxRating = sortedEvaluations.reduce(
      (acc, e) => acc + (e?.max_rating || 0),
      0
    )

    const ratingPercentage =
      totalMaxRating !== 0
        ? ((totalRating / totalMaxRating) * 100).toFixed(2)
        : '-'

    return [
      index + 1,
      { content: employee.id, styles: { textColor: '#0000FF', halign: 'left' } },
      { content: employee.name, styles: { textColor: '#0000FF', halign: 'left' } },
      { content: employee.designation.name, styles: { halign: 'left' } },
      { content: employee.branch.name, styles: { halign: 'left' } },
      { content: employee.department.name, styles: { halign: 'left' } },
      { content: wtGetDateMonthYearFormat(employee.date_of_joining)},
      ...sortedEvaluations.map((e) => ({
        content: e?.rating ? `${e.rating}/${e.max_rating}` : '-',
        styles: { halign: 'left' },
      })),
      `${totalRating > 0 ? totalRating + '/' + totalMaxRating : '-'}`,
      `${ratingPercentage > 0 ? ratingPercentage + '%' : '-'}`,
    ]
  })

  doc.autoTable({
    head: [headRows],
    body: employeeDetails,
    startY: 45,
    margin: { top: 50, bottom: 20, left: 10, right: 10 },
    theme: 'plain',
    tableLineColor: '#3c4b64',
    tableLineWidth: 0.2,
    tableWidth: 280,
    styles: { lineColor: '#3c4b64', lineWidth: 0.2, halign: 'center' },
    headStyles: {
      fillColor: '#fff',
      textColor: [60, 75, 100],
      setFontSize: 8,
      font: 'helvetica',
    },

    didDrawPage: function (data) {
      const pageNo = doc.internal.getNumberOfPages()
      const pageSize = doc.internal.pageSize
      const pageHeight = pageSize.height || pageSize.getHeight()
      const pageWidth = pageSize.width || pageSize.getWidth()

      doc.setTextColor('#3c4b64')
      doc.setFont('Helvetica', 'bold')

      doc.addImage(logo, 'PNG', pageWidth - 280, 4, 25, 25)
      doc.line(pageWidth - 254, 7, pageWidth - 254, 27)
      doc.setFontSize(11)
      doc.text('WAH', pageWidth - 251, 10)
      doc.setFont('Helvetica')
      doc.text('INDUSTRIES', pageWidth - 251, 15)
      doc.text('LIMITED', pageWidth - 251, 20)
      doc.setFontSize(9)
      doc.text('www.wahindustries.com', pageWidth - 251, 25)

      doc.setFontSize(14)
      doc.text('Performance Evaluation Summary Report', pageWidth - 20, 10, { align: 'right' })

      // Page Number
      let str = 'Page ' + pageNo
      if (typeof doc.putTotalPages === 'function') {
        str += ' of ' + totalPagesExp
      }
      doc.setFontSize(10)
      doc.setTextColor('black')
      doc.text(str, 10, pageHeight - 4)
    },
  })

  doc.setFontSize(10)
  const printReport = 'This Report is printed through ERP at ' + moment().format('YYYY-MM-DD HH:mm:ss')
  const styleReport = { halign: 'center' }
  const pageWidth = doc.internal.pageSize.width
  const textWidth = (doc.getStringUnitWidth(printReport) * doc.internal.getFontSize()) / doc.internal.scaleFactor
  const startX = (pageWidth - textWidth) / 2
  const startY = doc.autoTable.previous.finalY + 20
  doc.text(printReport, startX, startY, styleReport)

  const pdfBlob = doc.output('blob')
  const pdfUrl = URL.createObjectURL(pdfBlob)
  window.open(pdfUrl, '_blank')
}


  const changeValues = (key, val) => {
    if (key === 'department_id') {
      setDepartmentId(val.value)
      setDepartmentName(val.label)
    }

    if (key === 'designation_id') {
      setDesignationId(val.value)
      setDesignationName(val.label)
    }
    // if (key === 'employee_id') {
    //   setEmployeeId(val.value)
    //   setEmployeeName(val.label)
    // }
  }

  const getReportData = () => {
    if (range && range.length >= 2) {
      const fromDate = range[0]
      const toDate = range[1]
      setIsLoading(true)
      wtApiCall(
        'reports/employee_evaluation_summary_report',
        {
          from_date: fromDate.format('YYYY-MM-DD'),
          to_date: toDate.format('YYYY-MM-DD'),
          department_id: department_id,
          designation_id: designation_id,
        },
        'get',
        (response) => {
          const applicableEmployees = (response.data.data || []).filter((employee) =>
            (employee.evaluations || []).some(
              (evaluation) => !['NA', 'N/A'].includes(String(evaluation.status || '').toUpperCase()),
            ),
          )
          setReportData(applicableEmployees)
          setReportDataMonths(response.data.months)
          setIsLoading(false)
        },
        (error) => {
          lzNotifyErrorMessageFromResult(error)
          setIsLoading(false)
        },
      )
    } else {
      alert('Please select a valid date range.')
    }
  }

  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: 'Performance Evaluation Summary Report',
    sheet: 'Performance',
  })

  useEffect(() => {
    Base.dropdownData('designations,departments', {}, [setDesignations, setDepartments], 1)
  }, [])
  return (
    <>
      <div style={{ padding: '2%' }}>
        <center>
          <h4>Performance Evaluation Summary Report</h4>
        </center>
        <CRow style={{ width: '100%' }}>
          <CCol md={12}>
            <CCard className="card-dark">
              <CCardBody style={{ backgroundColor: '#f7f9fa' }}>
                <br />
                <CForm>
                  <CRow>
                    {/* <CCol md={1}></CCol> */}
                    <CCol md={1}>
                      <CInputGroup>
                        <label style={{ fontSize: '140%', marginTop: '50px' }}>Filters:</label>
                      </CInputGroup>
                    </CCol>
                    <CCol md={3}>
                      <div className="form-group">
                        <label>Date Range:</label>
                        <br />
                        <RangePicker value={range} onChange={setRange} size="middle" />
                      </div>
                    </CCol>
                    <CCol md={3}>
                      <CInputGroup>
                        <label>Designation</label>
                        <WidgetDesignationSelector
                          designations={designations}
                          displayValue={designation_name}
                          value={designation_id}
                          placeholder="Select Designation"
                          onChange={(values) => changeValues('designation_id', values)}
                          reloadDropdownData={() =>
                            Base.dropdownData('designations', {}, [setDesignations], 1)
                          }
                        />
                        {errors.designation_id && <ErrorMessage messages={errors.designation_id} />}
                      </CInputGroup>
                    </CCol>
                    <CCol md={3}>
                      <CInputGroup>
                        <label>Department</label>
                        <WidgetDepartmentSelector
                          departments={departments}
                          displayValue={department_name}
                          value={department_id}
                          placeholder="Select Department"
                          onChange={(values) => changeValues('department_id', values)}
                          reloadDropdownData={() =>
                            Base.dropdownData('departments', {}, [setDepartments], 1)
                          }
                        />
                        {errors.department_id && <ErrorMessage messages={errors.department_id} />}
                      </CInputGroup>
                    </CCol>
                    <CCol md={2}>
                      <CButton
                        color="primary"
                        onClick={() => getReportData()}
                        style={{ marginBottom: '20px', marginTop: '20px', marginLeft: '1%' }}
                      >
                        Search
                      </CButton>

                      <CButton
                        color="danger"
                        className="text-white"
                        style={{ marginBottom: '20px', marginTop: '20px', marginLeft: '1%' }}
                        onClick={generatePDF}
                      >
                        PDF
                      </CButton>
                      <CButton
                        color="success"
                        onClick={onDownload}
                        style={{ marginLeft: '1%' }}
                        className="text-white"
                      >
                        Export
                      </CButton>
                    </CCol>
                  </CRow>
                </CForm>
              </CCardBody>
            </CCard>
          </CCol>
        </CRow>
        <br />
        {/* <AttendanceReportLegends /> */}
        <CRow>
          <CCol md={12}>
            <table className="table table-bordered data-table" ref={tableRef}>
              {isLoading ? (
                Loading
              ) : (
                <>
                  {reportData.length > 0 ? (
                    <EvaluationSummaryReportDataTable
                      reportData={reportData}
                      reportDataMonths={reportDataMonths}
                      setReportData={(data) => setReportData(data)}
                      isLoading={isLoading}
                      ref={tableRef}
                    />
                  ) : (
                    <center style={{ fontSize: '19px', fontWeight: 'bold' }}>
                      No record to show...
                    </center>
                  )}
                </>
              )}
            </table>
          </CCol>
        </CRow>
      </div>
    </>
  )
}
